import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'valueToPercentage'
})
export class ValueToPercentage implements PipeTransform {

    transform(value: any): number {
        // {{22/33|valueToPercentage}}
        try {
            const top = +value.split('/')[0];
            const bottom = +value.split('/')[1];
            return +((top / bottom) * 100).toFixed(2);
        } catch (e) {

            return -1
        }
    }
}